import React, { useState } from 'react';
import Modal from '../../../../BaseModule/Components/Modal';
import { Size } from '../../../../../Enums/Size.enum';
import ShareChildrenWrapper from '../ShareChildrenWrapper/ShareChildrenWrapper';

interface Props {
	isOpen: boolean;
	onClose: () => void;
	childrenId: string;
}

const ShareChildrenModal: React.FC<Props> = ({
	isOpen,
	onClose,
	childrenId,
}) => {
	const [title, setTitle] = useState('component.shareChildren.step1.title');

	return (
		<Modal opened={isOpen} onClose={onClose} size={Size.SM}>
			<Modal.Header title={title} />
			<Modal.Content>
				<ShareChildrenWrapper
					childrenId={childrenId}
					setModalTitle={setTitle}
					onSuccess={onClose}
				/>
			</Modal.Content>
		</Modal>
	);
};

export default ShareChildrenModal;
